import React from "react";

const ScoreCard = ({ imageSrc, title, description }) => {
  return (
    <div className="flex flex-col items-center px-4 py-6 bg-white rounded-lg shadow-md">
      <img src={imageSrc} alt={title} className="w-20 h-20 mb-4" />
      <h2 className="text-xl font-bold">{title}</h2>
      <p className="text-base text-gray-700 px-10 text-center mt-2">{description}</p>
    </div>
  );
};

export default ScoreCard;
